import React from 'react';
import MultipleAddedMerchantsAction
  from "@/Pages/Merchants/Assets/MultipleAddedMerchantsAction/MultipleAddedMerchantsAction";

const AddedMerchantBottomPanel = ({handleCheckAll, checked, parentCheckbox}) => {

  return (
    <tfoot className='border-t'>
    <tr>
      <td className="px-1 pt-5 pb-4 w-1">
        <input type="checkbox" onChange={handleCheckAll} ref={parentCheckbox} defaultChecked={false}/>
      </td>
      <td>
        <MultipleAddedMerchantsAction checked={checked}/>
      </td>
    </tr>
    </tfoot>
  );
};

export default AddedMerchantBottomPanel;
